import React, { useEffect } from 'react';
/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import moment from 'moment';
import App from '../app';
import Container from '../ui/container';
import MediaPopup from '../screens/media-popup';
import theme from '../ui/theme';

import join_prize_2026_jpg from '../img/prize/2026/join-prize.png';
import continue_3m_prize_2026_jpg from '../img/prize/2026/continue-3m-prize.png';
import continue_6m_prize_2026_jpg from '../img/prize/2026/continue-6m-prize.png';
import continue_1y_prize_2026_jpg from '../img/prize/2026/continue-1y-prize.png';

const prizes = {
  j: {
    media: {
      name: '入会特典',
      image: {
        2026: join_prize_2026_jpg,
      },
      caption: `ISM FCのご入会ありがとうございます。
        楽しいコンテンツをお届けできるよう運営してまいりますので、
        今後ともISM FCをよろしくお願い申し上げます。`
    }
  },
  m3: {
    media: {
      name: '入会3ヶ月特典',
      image: {
        2026: continue_3m_prize_2026_jpg,

      },
      caption: `いつもISM FCのご利用ありがとうございます。
        入会3ヶ月特典をお届け致します。
        今後ともISM FCをよろしくお願い申し上げます。`
    }
  },
  m6: {
    media: {
      name: '入会6ヶ月特典',
      image: {
        2026: continue_6m_prize_2026_jpg,

      },
      caption: `いつもISM FCのご利用ありがとうございます。
        入会6ヶ月特典をお届け致します。
        今後ともISM FCをよろしくお願い申し上げます。`
    }
  },
  y1: {
    media: {
      name: '入会1年特典',
      image: {
        2026: continue_1y_prize_2026_jpg,
      },
      caption: `いつもISM FCのご利用ありがとうございます。
        入会1年特典をお届け致します。
        今後ともISM FCをよろしくお願い申し上げます。`
    }
  }
};

export default () => {
  const app = React.useContext(App);
  const ended_at = moment('2026-01-31T23:59:59+09:00');

  useEffect(() => {
    const interval = setInterval(() => {
      if (moment().isAfter(ended_at)) {
        // Force re-render by updating state or context
        window.location.reload();
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, [ended_at]);

  if (moment().isAfter(ended_at)) {
    return <></>
  }
  const prize = prizes['m6'];
  return (
    <Container>
      <div css={{marginTop: 60}}>
        <div css={{
          backgroundColor: theme.colors.background,
          flex: 'auto'
        }}>
        <img css={{display: 'block', width: '100%', height: 'auto', cursor: 'pointer'}} src={prize.media.image[2026]} onClick={() => { app.push(<MediaPopup media={{image: prize.media.image[2026]}}/>)}}/>
        <div css={{padding: 12}}>{prize.media.caption.split('\n').map((t) => (
            <>{t}<br/></>
        ))}</div>
        <div css={{padding: 12, marginTop: 15, fontSize: 12}}>
          *特典画像は{ended_at.format('MM月DD日 HH:mm')}まで表示されます
        </div>
        </div>
      </div>
    </Container>
  );
};
